/**
 * this is the height of the app's navigation bar,
 * as of writing this, it is a fixed height at any screen size
 */
export const APP_NAV_HEIGHT = 65;
/**
 * this is the width used when a page's content
 * should not fill the entire width of the screen
 */
export const APP_CONTENT_MAX_WIDTH = 1280;
